import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ShieldPlus, WarningCircle } from "@phosphor-icons/react";

export default function InsuranceSummaryCard() {
  const [s, setS] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/insurance/summary").then((r) => setS(r.data)).catch(() => setS(null)); }, []);
  if (!s) return null;
  const rows = [
    { key: "expiring", label: "policies expiring soon", n: s.expiring_soon_count, to: "/insurance?status=expiring", tone: "amber" },
    { key: "expired", label: "policies expired", n: s.expired_count, to: "/insurance?status=expired", tone: "red" },
    { key: "uninsured", label: "vehicles with no valid cover", n: s.uninsured_count, to: "/assets?insurance=uninsured", tone: "red" },
    { key: "renewaldocs", label: "renewal documents outstanding", n: s.renewal_docs_outstanding_count, to: "/insurance?renewal=outstanding", tone: "amber" },
  ].filter((r) => r.n > 0);
  const total = rows.reduce((a, r) => a + r.n, 0);
  return (
    <div data-testid="insurance-summary-card" className="bg-white border-2 border-slate-200 rounded-lg">
      <div className="flex items-center justify-between px-4 py-3 border-b-2 border-slate-200 bg-slate-50">
        <h2 className="font-display text-lg font-black text-slate-900 flex items-center gap-2"><ShieldPlus size={20} weight="bold" />Insurance</h2>
        <button data-testid="insurance-summary-open" onClick={() => nav("/insurance")} className="text-sm text-blue-600 font-semibold">Open register →</button>
      </div>
      <div className="p-4">
        {total === 0 ? (
          <p data-testid="insurance-summary-clear" className="text-sm text-emerald-700 font-semibold">All policies current — nothing needs attention.</p>
        ) : (
          <div className="flex flex-col gap-1.5">
            {rows.map((r) => (
              <button key={r.key} data-testid={`insurance-summary-${r.key}`} onClick={() => nav(r.to)}
                className={`flex items-center gap-2 text-left rounded px-2 py-1.5 hover:bg-slate-50 ${r.tone === "red" ? "text-red-700" : "text-amber-700"}`}>
                <WarningCircle size={18} weight="fill" />
                <span className="font-display font-black text-lg">{r.n}</span>
                <span className="font-body text-sm text-slate-700">{r.label}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
